module.exports = __webpack_public_path__ + "img/screenshot-8.282e0eb7.webp";